module.exports = __webpack_public_path__ + "img/opoint-logo.5f335b02.svg";